module.exports = __webpack_public_path__ + "static/media/delete.064f6ebf.svg";